// @flow
import SidebarShowButton from './SidebarShowButton';

export default SidebarShowButton;
